import { getLocalizedValue } from '../app/shared/utils/performance.utils';
import { Product, Program } from './program.model';

export interface ApiProgramResponse {
  id: string;
  display_labels: string | { [locale: string]: string };
  status: string;
}

export interface ApiProductResponse {
  id: string;
  display_labels: string | { [locale: string]: string };
  program_id: string;
  status: string;
}

export function mapApiProgram(api: ApiProgramResponse, locale: string): Program {
  return {
    id: api.id,
    name: getLocalizedValue(api.display_labels, locale),
  };
}

export function mapApiProduct(api: ApiProductResponse, locale: string): Product {
  return {
    id: api.id,
    name: getLocalizedValue(api.display_labels, locale),
  };
}
